{
	"title": "Notificaciones",
	"read": "Todos",
	"unread": "No leídos",
	"emptyNotifications": "¡Has llegado al final de la lista!",
	"emptyUnreadNotifications": "¡Estás actualizado de todas las noticias!",
	"noNews": "¡Sin novedades!",
	"levelTag": "Nivel {{tag}}",
	"classification": {
		"alert": "Inestabilidad",
		"release": "Lanzamiento",
		"warning": "Mejora"
	},
	"level": {
		"app": "App del usuario",
		"organization": "Organización",
		"place": "Ubicación",
		"event": "Evento",
		"pdv": "Pdv"
	},
	"onboarding": {
		"modularization": {
			"title": "Presentando el <strong>Nuevo Menú Zig</strong>",
			"content": "<strong>Ahora puedes...</strong> ver tu historial financiero de manera detallada y personalizada, con filtros avanzados y reportes que facilitan el seguimiento de tus transacciones.",
			"primaryActionLabel": "Saber más",
			"secondaryActionLabel": "Saltar"
		},
		"bonusReport": {
			"title": "Sigue los bonos concedidos y utilizados",
			"content": "Ahora puedes hacer seguimiento de los bonos concedidos y utilizados a partir de informes detallados con el total distribuido, nombre del cliente, empleado, motivo y valor. Consulta el nuevo informe accediendo a la pestaña de Bonos en los informes financieros de tu ubicación.",
			"primaryActionLabel": "Cerrar"
		},
		"salesReport": {
			"title": "¡Ahora se llama Informes de Ventas!",
			"content": "El antiguo Informe de Bar todavía existe, pero ahora se llama Informes de Ventas. Para acceder a él, ve al menú del local y haz clic en la pestaña 'Informes de Ventas'.",
			"primaryActionLabel": "Cerrar"
		}
	}
}
